export default "__VITE_ASSET__C1gOEJ4x__";